import api from '@edu-fe/api'

export default {
    name: 'mediaCourse',
    getCourseDetail: (params) => api.create(`/media/course/detail?orgMediaInfoId=${params.orgMediaInfoId}`),
}
